import * as React from 'react';

import { Checkbox } from 'antd';
import PropTypes from 'prop-types';

import s from './NotificationSettings.pcss';


// const Panel = Collapse.Panel;

export default class NotificationSettingItem extends React.Component {
  static propTypes = {
    setting: PropTypes.shape().isRequired,
    disabled: PropTypes.bool.isRequired,
    // allLockedHasNotification: PropTypes.string.isRequired,
    allUsersHasNotification: PropTypes.string.isRequired,
    onChangeSetting: PropTypes.func.isRequired,
  };

  // state = {
  //   activeKey: '',
  // };

  // setActive = () => this.setState({ activeKey: !this.state.activeKey ? '1' : '' });
  prevent = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault();
  };

  renderHeader = () => {
    // const collapsed = this.state.activeKey === '1';
    const { allUsersHasNotification, disabled } = this.props;
    const isChecked = allUsersHasNotification === 'yes';
    return (
      <div className={s.setting}>
        <div onClick={this.prevent}>
          <div onClick={() => this.props.onChangeSetting(!isChecked)}>
            <Checkbox
              disabled={disabled}
              checked={isChecked}
              indeterminate={allUsersHasNotification === 'indeterminate'}
            />
          </div>
        </div>
        <div className={s.description}>
          {this.props.setting.description}
        </div>
        {/* collapsed
          ? <Icon type="caret-down" />
          : <Icon type="caret-right" />
         */}
      </div>
    );
  };

  render() {
    return (
      <div className={s.settingContainer}>
        {this.renderHeader()}
      </div>
    );
  }

  // uncomment when it will be actual - ability of admins to lock users actions for notifications
  // render() {
  //   const { allLockedHasNotification, disabled } = this.props;
  //   return (
  //     <div className={s.settingContainer}>
  //       <Collapse activeKey={this.state.activeKey} onChange={this.setActive}>
  //         <Panel showArrow={false} header={this.renderHeader()} disabled={disabled} key="1">
  //           <div className={s.setting}>
  //             <div onClick={this.prevent}>
  //               <Checkbox
  //                 disabled={disabled}
  //                 checked={allLockedHasNotification === 'yes'}
  //                 indeterminate={allLockedHasNotification === 'indeterminate'}
  //                 onChange={e => this.props.onChangeSetting(e.target.checked, 'lock')}
  //               />
  //             </div>
  //             <div className={s.description}>
  //               Пользователь не сможет вносить изменения в настройки уведомлений
  //             </div>
  //           </div>
  //         </Panel>
  //       </Collapse>
  //     </div>
  //   );
  // }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Notifications/NotificationSettings/NotificationSettingItem.js